import { Card, Divider, Button } from "antd";
import React, { useState } from "react";
import EmployeeProfile from "./EmployeeProfile";


const PerformanceCard = (props) => {
  const { recordData, children } = props;

  return (
    
      <Card className="rounded-2xl border border-gray-200 hover:shadow-md relative dark-mode-card" >
        <div className="flex justify-between items-start">
          <span className={`absolute items-center right-5 text-xs border status-indicator ${recordData?.due_status?.toLowerCase().replace(/\s+/g, "-")}`}>
            {recordData?.due_status}
          </span>
          <EmployeeProfile 
            record={recordData?.employee}
            withEmpId={false}
            withEmpJobTitle={true}
            nameInitialBg="bg-emerald-100 text-emerald-700"
            empNameClass="font-semibold text-gray-800 dark:text-white"
            empJobTitleClass="text-gray-600 text-sm dark:text-slate-100"
          />
        </div>

        <Divider style={{ margin: "0.5rem 0", borderColor: "#e5e7eb" }} />

        <div className="text-sm text-gray-700 my-2">
          <div className="flex justify-between">
            <p className="font-semibold dark:text-slate-100">{recordData?.task_title}</p>
          </div>
          <div className="flex justify-between ">
            <p className="dark:text-slate-100">Review Month:</p>
            <p className="font-semibold text-gray-700 dark: dark:text-slate-200">{recordData?.review_month}</p>
          </div>
          
        </div>
        
        {children}
      </Card>
  );
};

export default PerformanceCard;
